import React from 'react'
import RewardLeaderboardPage from './RewardLeaderboardPage'

const RewardLossPage: React.FC = () => <RewardLeaderboardPage tab="loss" />

export default RewardLossPage
